import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import * as consts from '../consts.js';

import SectionHeader from './sectionheader.js';

function Stats(props) {
    // const [data, setData] = useState(null);
    const [randomData, setRandomData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM \`Capability Stats\` WHERE \`Capability\` IN ('${props.capability}')`;
        // setData(null);
        setRandomData(null);

        try {
          const rows = await execSeatableSql(sql);
          // setData(rows && rows.results);
          setRandomData(getRandomSet(rows && rows.results, 4));
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]);

    const getRandomSet = (source, count) => {
      if (source && (source.length <= count)) return source;

      let clone = [...source];
      let target = [];
      while (target.length < count) {
        const randomIndex = Math.floor(Math.random() * Math.min(count, clone.length));
        target.push(clone[randomIndex]);
        clone.splice(randomIndex, 1);
      }

      return target;
    }

    return (
      <>
        {(randomData && (randomData.length > 0)) ? <>
            <div id="Stats" className='nav-margin'>
              <SectionHeader capability={props.capability} section="Stats"/>
            </div>
            <div className="stats pb-5 border-bottom border-secondary">
              {randomData.map((row, index) => {
                  return (
                      <div key={index} >
                          <div className="my-3" style={{width: "30px", height: "10px", backgroundColor: `${consts.colorPalette[index%9]}`}}></div>
                          <h1 className="mb-3 lato-black">{row.Stat}</h1>
                          <h4 className="lato-light">{row.Desc}</h4>
                      </div>
                  )
              })}
            </div>
        </> : ''}
      </>
    )
}

export default Stats;